export default "__VITE_ASSET__5f7c779c__"